const { createReducer } = require("../helpers");
const {
  CREATE_KYC_USER,
  CREATE_KYC_USER_SUCCESS,
  CREATE_KYC_USER_RESET,
  CREATE_KYC_USER_ERROR,

  GET_KYC_USER,
  GET_KYC_USER_SUCCESS,
  GET_KYC_USER_ERROR,
  GET_KYC_USER_RESET,

  UPDATE_KYC_USER,
  UPDATE_KYC_USER_SUCCESS,
  UPDATE_KYC_USER_RESET,
  UPDATE_KYC_USER_ERROR,
} = require("./constants");

const initialState = {
  createUser: {
    data: {},
    loading: false,
    error: null,
  },
  getUser: {
    data: {},
    loading: false,
    error: null,
  },
  updateUser: {
    data: {},
    loading: false,
    error: null,
  },
};

module.exports = createReducer(
  {
    [CREATE_KYC_USER]: (draft) => ({
      createUser: {
        ...draft.createUser,
        loading: true,
        error: null,
      },
    }),
    [CREATE_KYC_USER_SUCCESS]: (draft, action) => ({
      createUser: {
        ...draft.createUser,
        data: action.payload.data,
        loading: false,
      },
    }),
    [CREATE_KYC_USER_ERROR]: (draft, action) => ({
      createUser: {
        ...draft.createUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CREATE_KYC_USER_RESET]: () => ({
      createUser: { ...initialState.createUser },
    }),

    [GET_KYC_USER]: (draft) => ({
      getUser: {
        ...draft.getUser,
        loading: true,
        error: null,
      },
    }),
    [GET_KYC_USER_SUCCESS]: (draft, action) => ({
      getUser: {
        ...draft.getUser,
        data: action.payload.data,
        loading: false,
      },
    }),
    [GET_KYC_USER_ERROR]: (draft, action) => ({
      getUser: {
        ...draft.getUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_KYC_USER_RESET]: () => ({
      getUser: { ...initialState.getUser },
    }),

    [UPDATE_KYC_USER]: (draft) => ({
      updateUser: {
        ...draft.updateUser,
        loading: true,
        error: null,
      },
    }),
    [UPDATE_KYC_USER_SUCCESS]: (draft, action) => ({
      updateUser: {
        ...draft.updateUser,
        data: action.payload.data,
        loading: false,
      },
    }),
    [UPDATE_KYC_USER_ERROR]: (draft, action) => ({
      updateUser: {
        ...draft.updateUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [UPDATE_KYC_USER_RESET]: () => ({
      updateUser: { ...initialState.updateUser },
    }),
  },
  initialState
);
